import React from 'react';
import { Box } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import { useHasAccess } from '@/modules/core';
import {
  SETUP_CONTAINER_UI_ID,
} from '@/modules/core/hooks/useDetectActiveTOCModule';

import { PLAN_MODULES } from '../plan.constants';
import { PlanStatuses } from '../plan.types';

import { usePlanModules, useProgressScroll } from './Sidebar/hooks';
import Sidebar from './Sidebar';

interface Props {
  children: React.ReactNode;
  planStatus?: PlanStatuses;
  isTemplateMode?: boolean;
  isPlanActive?: boolean;
}
const PlanSetupWrapper: React.FC<Props> = ({
  children,
  planStatus,
  isTemplateMode,
  isPlanActive,
}) => {
  const hasActivityLog = useHasAccess([{ permission: Permissions.VIEW_PROFILE }]);
  const config = usePlanModules(hasActivityLog ? undefined : [PLAN_MODULES.ACTIVITY_LOG]);

  const { onScrollHandler, scrollToSection } = useProgressScroll(config);

  return (
    <Box
      direction="row"
      overflow="hidden"
      flex={{ grow: 1 }}
    >
      <Sidebar
        planStatus={planStatus}
        scrollToSection={scrollToSection}
        isTemplateMode={isTemplateMode}
        isPlanActive={isPlanActive}
      />
      <Box
        fill
        overflow="auto"
        onScroll={onScrollHandler}
        id={SETUP_CONTAINER_UI_ID}
        align="center"
      >
        {children}
      </Box>
    </Box>
  );
};

export default PlanSetupWrapper;
